import { CHANNEL, TRIGGER_CHANNEL } from '../constants/messageTemplateKeys';

// Template channel email/sms/mms → trigger channel email/text (sms and mms are text).
export function resolveTriggerChannel(channel) {
  return channel === CHANNEL.EMAIL ? TRIGGER_CHANNEL.EMAIL : TRIGGER_CHANNEL.TEXT;
}
